import { renderRelationshipLabelLabelTemplate } from '@next-adapter/templates/renderers/generators/columns/column-defs/generate-relationship-label.js'
export function generateRelationshipLabel(valueExpression: string): string {
  return renderRelationshipLabelLabelTemplate({ valueExpression: valueExpression })
}
